import type { Theme } from '@mui/material/styles';

export const ACCOUNT_MENU_WIDTH = 320;

export function getAccountMenuPaperSx(theme: Theme, width: number | string = ACCOUNT_MENU_WIDTH) {
  return {
    mt: 1,
    width,
    maxWidth: 'calc(100vw - 32px)',
    overflow: 'hidden',
    bgcolor: theme.vars.palette.background['paper-elevation-3'],
  };
}

export const accountMenuSectionDividerSx = {
  mx: -1.5,
  borderColor: 'elevation.outlined',
} as const;

export const accountMenuGhostIconButtonSx = {
  color: 'text.secondary',
  p: 0.5,
  '&:hover': { color: 'text.primary', bgcolor: 'action.hover' },
} as const;
